/**
 * DataTree component operates on row id's, but organizations coming from network will have identical ids.
 * Need to append id of parent to row before using it to make all row id's unique
 * */
export function makeUniqueIds(orgs, parent) {
    for (const org of orgs) {
        if (parent) {
            org.id += '_' + parent.id;
        }
        makeUniqueIds(org.children, org);
    }
}
